import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from "../Loading";
import axios from "axios";
import {APIURL, PORT} from "../../config/config";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DatePicker from "react-datepicker";
import {checkDocNo, setInputStyleDocNo} from "../../services/docLogService";
import * as moment from "moment";
import {DateUtil} from "../../utils/dateUtil";
import {NumberUtil} from "../../utils/number-util";
import ThaiBaht from "thai-baht-text";
import NumberFormat from "react-number-format";
import {format} from "date-fns";
// import {checkGroupPermission} from "../../services/grouppermission";
import {AlertSuccess, AlertWarning} from "../Alert/Alert";
// import { isNumber } from 'chart.js/helpers';

const port = Number(window.env.PORT);

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew-Regular.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf'
    },
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    }
}

class PaymentVoucher extends Component {
    constructor(props) {
        super(props)
        this.state = {
            car: {},
            car_repair: {},
            user: {},
            payment_voucher: null,
            payment_voucher_id: null,
            isLoading: false,

            logoBase64Img: '',
            company_setting: null,

            startDatePaymentVoucher: new Date(), // moment(),
            isOpenDatePaymentVoucher: false,

            payment_voucher_date: null,
            payment_voucher_date_thai: null,
            pay_method : 'cash',
            pay_method_detail: '',
            payee_name: '',
            payer_name: '',
            approver_name: '',
            payment_voucher_number: '',
            payment_voucher_number_current: null,
            status_bill : 0,
            payment_voucher_name: '',
            payment_voucher_amount: 0,

            center_id: '',
            center_name: '',
            center_address: '',
            center_tax_number: '',
            car_repair_name: '',
            car_repair_cost: 0,

            car_id: '',
            car_repair_id: '',
            expense_id: null,
            expense_type_id: null,
            //
            payment_voucher_type: '',
            car_sell_id: '',
            payment_voucher_details: [],
            sum_totals: 0,
            author_name: '',
            reviewer_name: '',
        }

        this.loadCompanySetting = this.loadCompanySetting.bind(this);
        this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
        this.handleDatePaymentVoucher = this.handleDatePaymentVoucher.bind(this);
        this.loadPaymentVoucher = this.loadPaymentVoucher.bind(this);
        this.loadCarRepairData = this.loadCarRepairData.bind(this);
        this.loadCarSellData = this.loadCarSellData.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.checkPaymentVoucherNumberRepeat = this.checkPaymentVoucherNumberRepeat.bind(this);
        this.savePaymentVoucher = this.savePaymentVoucher.bind(this);
        this.manageAddEditButton = this.manageAddEditButton.bind(this);
        this.managePrintButton = this.managePrintButton.bind(this);
        this.renderPaymentVoucherTable = this.renderPaymentVoucherTable.bind(this);
        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.onChangeInputNumber = this.onChangeInputNumber.bind(this);
        this.calSumTotals = this.calSumTotals.bind(this);
        this.printPaymentVoucher = this.printPaymentVoucher.bind(this);
        this.printPaymentVoucherCarSell = this.printPaymentVoucherCarSell.bind(this);
    }

    handleDatePaymentVoucher (date) {
        let payment_voucher_date =  format(date, 'yyyy-MM-dd')
        let payment_voucher_date_thai = DateUtil.convertLongDateThai(payment_voucher_date)

        this.setState({
            startDatePaymentVoucher : date,
            isOpenDatePaymentVoucher : false,
            payment_voucher_date: payment_voucher_date,
            payment_voucher_date_thai: payment_voucher_date_thai
        })
    }

    async loadCompanySetting () {
        await axios.get(APIURL + '/company_setting/1')
            .then(res => {
                let data = res.data
                let company_setting = data.company_setting
                this.setState({
                    company_setting: company_setting
            })
        })
    }

    async loadCompanyLogoBase64() {
        let uri =  APIURL + '/company_setting/logoimage/1';
        await axios.get(uri)
            .then(res => {
                let body = res.data.body
                this.setState({ logoBase64Img: body })
            }).catch(error => {
                console.log('error:', error)
            })
    }

    async loadPaymentVoucher(){
        const {
            payment_voucher_type,
            car_sell_id,
            car_repair_id
        } = this.state
        let url = ''

        // let payment_voucher_details = []
        if (payment_voucher_type==='car_repair'){
            url = APIURL + '/payment_voucher/car_repair/' + car_repair_id
        }else if (payment_voucher_type==='car_sell') {
            url = APIURL + '/payment_voucher/car_sell/' + car_sell_id
        }

        // กรณีมีข้อมูล ใบสำคัญจ่ายแล้ว
        await axios.get(url)
            .then(res =>{
                let data = res.data
                if(data.length === 1){
                    let paymentvoucher = data[0];

                    let payment_voucher_date = moment(paymentvoucher.payment_voucher_date).format('YYYY-MM-DD')
                    let payment_voucher_date_thai = DateUtil.convertLongDateThai(payment_voucher_date)

                    // if (payment_voucher_type==='car_sell') {
                    //     payment_voucher_details = paymentvoucher.payment_voucher_details
                    // }

                    this.setState({
                        payment_voucher : paymentvoucher,
                        payment_voucher_id : paymentvoucher.payment_voucher_id,
                        payment_voucher_number : paymentvoucher.payment_voucher_number,
                        payment_voucher_date : paymentvoucher.payment_voucher_date,
                        payment_voucher_date_thai : payment_voucher_date_thai,
                        payee_name : paymentvoucher.payee_name,
                        payer_name : paymentvoucher.payer_name,
                        approver_name : paymentvoucher.approver_name,
                        pay_method : paymentvoucher.pay_method,
                        pay_method_detail : paymentvoucher.pay_method_detail,
                        center_id : paymentvoucher.center_id,
                        car_repair_id : paymentvoucher.car_repair_id,
                        expense_id : paymentvoucher.expense_id,
                        expense_type_id : paymentvoucher.expense_type_id,

                        car_sell_id : paymentvoucher.car_sell_id ,
                        customer_id : paymentvoucher.customer_id,

                        center_name : paymentvoucher.center_name,
                        center_address : paymentvoucher.center_address,
                        center_tax_number : paymentvoucher.center_tax_number,
                        car_repair_name : paymentvoucher.payment_voucher_name,
                        car_repair_cost : paymentvoucher.payment_voucher_amount,

                        author_name : paymentvoucher.author_name,
                        reviewer_name : paymentvoucher.reviewer_name,
                        // payment_voucher_details: payment_voucher_details
                    })
                }
            })
            .catch(err => {
                console.log('err: ', err)
            })
    }

    async loadCarRepairData(){
        let payment_voucher_id = this.state.payment_voucher_id

        if (payment_voucher_id !== null) {
            return
        }

        // load for create new payment_voucher
        await axios.get(APIURL + '/car_repair/' +this.state.car_repair_id)
            .then(res => {
                if(this.mounted) {
                    let car_repair = res.data[0]
                    let center_name = car_repair.center_name
                    let center_address = car_repair.center_address
                    let center_tax_number = car_repair.center_tax_number
                    let car_repair_name = car_repair.car_repair_name
                    let car_repair_cost = car_repair.car_repair_cost
                    let center_id = car_repair.center_id

                    this.setState({
                        car_repair : car_repair,
                        center_name,
                        center_address,
                        center_tax_number,
                        car_repair_name,
                        car_repair_cost,
                        center_id,
                    })
                }
            }).catch(error => {
                // alert("error"+error)
                this.setState({car_repair: {}})
            })
    }

    async loadPaymentVoucherDetailData() {
        let payment_voucher_id = this.state.payment_voucher_id
        let payment_voucher_type = this.state.payment_voucher_type
        let url = ''
        if (payment_voucher_id === null && payment_voucher_type==='car_sell') {
            // load from payment_voucher_setting
            url = APIURL + '/payment_voucher/setting/'+payment_voucher_type
        } else {
            url = APIURL + '/payment_voucher/details/'+payment_voucher_id
        }

        await axios.get(url)
            .then(res => {
                if(this.mounted) {
                    let payment_voucher_details =  res.data
                    this.setState({
                        payment_voucher_details: payment_voucher_details
                    },() => this.calSumTotals())
                }
            }).catch(error => {
                console.log('error:', error)
            })
    }

    async loadCarSellData() {
        let payment_voucher_id = this.state.payment_voucher_id

        if (payment_voucher_id !== null) {
            await this.loadPaymentVoucherDetailData();
            return
        }

        // load for create new payment_voucher
        await axios.get(APIURL + '/car_sell/' +this.state.car_sell_id)
            .then(res => {
                if(this.mounted) {
                    let car_sell = res.data[0]
                    let center_name = car_sell.customer_name+' '+car_sell.customer_lastname
                    let center_address = car_sell.customer_address
                    let center_tax_number = car_sell.customer_card_id
                    let car_repair_name = ''
                    let car_repair_cost = ''
                    // let center_id = ''
                    let customer_id = car_sell.customer_id

                    this.setState({
                        car_sell : car_sell,
                        center_name,
                        center_address,
                        center_tax_number,
                        car_repair_name,
                        car_repair_cost,
                        customer_id
                    })
                }
            }).catch(error => {
                // alert("error"+error)
                this.setState({car_sell: {}})
            })

    }

    handleOnChange(e) {
        let name = e.target.name;
        let val = e.target.value;

        this.setState({
            [name]: val
        })
    }

    async checkPaymentVoucherNumberRepeat(){
        let doc_no = this.state.payment_voucher_number
        let payment_voucher_number_current = this.state.payment_voucher_number_current

        if(doc_no === ''){
            return
        }

        if (payment_voucher_number_current !== null && doc_no === payment_voucher_number_current ) {
            return
        }

        let data = await checkDocNo(doc_no)

        this.setState({
            check_doc_no : data
        })
    }

    savePaymentVoucher(action){
        let payment_voucher_type = this.state.payment_voucher_type
        let payment_voucher_number = this.state.payment_voucher_number
        let payment_voucher_date = this.state.payment_voucher_date
        let payment_voucher_date_thai = this.state.payment_voucher_date_thai
        let payee_name = this.state.payee_name
        let payer_name= this.state.payer_name
        let approver_name= this.state.approver_name
        let pay_method= this.state.pay_method
        let pay_method_detail= this.state.pay_method_detail
        let status_bill= this.state.status_bill
        let center_id= this.state.center_id
        let car_repair_id= this.state.car_repair_id
        let expense_id= this.state.expense_id
        let expense_type_id= this.state.expense_type_id
        let center_name= this.state.center_name
        let center_address= this.state.center_address
        let center_tax_number= this.state.center_tax_number
        let payment_voucher_name= this.state.car_repair_name
        let payment_voucher_amount= this.state.car_repair_cost

        let author_name = this.state.author_name
        let reviewer_name= this.state.reviewer_name

        let data = {
            payment_voucher_number : payment_voucher_number,
            payment_voucher_date : payment_voucher_date,
            payee_name : payee_name,
            payer_name : payer_name,
            approver_name : approver_name,
            pay_method : pay_method,
            pay_method_detail : pay_method_detail,
            status_bill : status_bill,
            center_id : center_id,
            car_repair_id : car_repair_id,
            expense_id : expense_id,
            expense_type_id : expense_type_id,
            center_name : center_name,
            center_address : center_address,
            center_tax_number : center_tax_number,
            payment_voucher_name : payment_voucher_name,
            payment_voucher_amount : payment_voucher_amount,
            user_created: this.state.user.user,
            user_updated: this.state.user.user,
            author_name : author_name,
            reviewer_name : reviewer_name,
        }

        if (payment_voucher_type === 'car_repair') {
            this.setState({
                isLoading: true,
            }, () => {
                if (action === 'add') {
                    let url = APIURL + '/payment_voucher';
                    axios.post(url, data)
                        .then(res => {

                            if (res.status === 200) {
                                let resData = res.data
                                let payment_voucher_id = resData.payment_voucher_id;

                                AlertSuccess('บันทึกใบสำคัญจ่ายเรียบร้อยแล้ว');
                                this.setState({
                                    isLoading: false,
                                    payment_voucher_id: payment_voucher_id
                                    // isExist: true,
                                }, () => this.loadPaymentVoucher())
                            }
                        }).catch(error => {
                        console.log('error:', error)
                    });
                } else if (action === 'edit') {
                    let payment_voucher_id = this.state.payment_voucher_id
                    let editData = {...data, payment_voucher_id: payment_voucher_id}
                    let url = APIURL + '/payment_voucher';
                    axios.put(url, editData)
                        .then(res => {
                            if (res.data === 'success') {
                                AlertWarning('แก้ไขใบสำคัญจ่ายเรียบร้อยแล้ว');
                                this.setState({
                                    isLoading: false,
                                }, () => this.loadPaymentVoucher())
                            }
                        }).catch(error => {
                        console.log('error:', error)
                    });
                }
            })
        } else if (payment_voucher_type === 'car_sell') {
            let customer_id = this.state.customer_id
            let car_sell_id = this.state.car_sell_id
            let sum_totals = this.state.sum_totals
            let payment_voucher_details = this.state.payment_voucher_details

            if (sum_totals === 0) {
                AlertWarning('กรุณากรอกจำนวนเงินอย่างน้อย 1 รายการ');
                return;
            }

            data = {...data,
                customer_id: customer_id,
                car_sell_id: car_sell_id,
                payment_voucher_type: payment_voucher_type,
                payment_voucher_amount: sum_totals,
                payment_voucher_details: payment_voucher_details
            };

            if (action === 'add') {
                let url = APIURL + '/payment_voucher';
                this.setState({
                    isLoading: true,
                }, () => {
                    axios.post(url, data)
                        .then(res => {
                            if (res.status === 200) {
                                let resData = res.data
                                let payment_voucher_id = resData.payment_voucher_id;

                                AlertSuccess('บันทึกใบสำคัญจ่ายเรียบร้อยแล้ว');
                                this.setState({
                                    isLoading: false,
                                    payment_voucher_id: payment_voucher_id
                                    // isExist: true,
                                }, async () => {
                                    await this.loadPaymentVoucher();
                                    await this.loadPaymentVoucherDetailData();
                                })
                            }
                        }).catch(error => {
                        console.log('error:', error)
                    });
                });
            } else if (action === 'edit') {
                let payment_voucher_id = this.state.payment_voucher_id
                let payment_voucher_detail_filters = payment_voucher_details.filter(pvd => pvd.form_status === 'edit')
                let editData = {
                    ...data,
                    payment_voucher_id: payment_voucher_id,
                    payment_voucher_details: payment_voucher_detail_filters
                }

                let url = APIURL + '/payment_voucher';
                axios.put(url, editData)
                    .then(res => {
                        if (res.data === 'success') {
                            AlertWarning('แก้ไขใบสำคัญจ่ายเรียบร้อยแล้ว');
                            this.setState({
                                isLoading: false,
                            }, async () => {
                                await this.loadPaymentVoucher();
                                await this.loadPaymentVoucherDetailData();
                            })
                        }
                    }).catch(error => {
                    console.log('error:', error)
                });

            }
        }
    }

    printPaymentVoucher(){
        const {company_setting, logoBase64Img} = this.state

        let company_name = company_setting.company_name
        let company_address = company_setting.company_address
        let juristic_number = company_setting.juristic_number
        let company_tel = company_setting.company_tel === '' ? '-' : company_setting.company_tel
        let head_line3 = 'โทร. '+ company_tel + ' เลขประจำตัวผู้เสียภาษี '+ juristic_number

        let payment_voucher_number = this.state.payment_voucher_number
        let payment_voucher_date = this.state.payment_voucher_date
        let payment_voucher_date_thai = this.state.payment_voucher_date_thai
        let payee_name = this.state.payee_name === null || this.state.payee_name === '' ? '(.................................................................)' : '( '+this.state.payee_name+' )'
        let payer_name= this.state.payer_name === null || this.state.payer_name === '' ? '(.................................................................)' : '( '+this.state.payer_name+' )'
        let approver_name= this.state.approver_name === null || this.state.approver_name === '' ? '(.................................................................)' : '( '+this.state.approver_name+' )'
        let pay_method= this.state.pay_method
        let pay_method_detail= this.state.pay_method_detail
        let status_bill= this.state.status_bill
        let center_id= this.state.center_id
        let car_repair_id= this.state.car_repair_id
        let expense_id= this.state.expense_id
        let expense_type_id= this.state.expense_type_id
        let center_name= this.state.center_name
        let center_address= this.state.center_address
        let center_tax_number= this.state.center_tax_number
        let payment_voucher_name= this.state.car_repair_name
        let payment_voucher_amount= this.state.car_repair_cost

        let pay_method_type
        if(pay_method === 'cash'){
            pay_method_type = 'เงินสด'
        }else if(pay_method === 'transfer'){
            pay_method_type = 'เงินโอน'
        }else {
            pay_method_type = 'เช็ค' + ' ' + pay_method_detail
        }

        let payment_voucher_amount_text = ThaiBaht(payment_voucher_amount);

        let headerLeft
        let headerCenter
        let logo_width = 90
        if (company_address.length >=60 || head_line3.length >= 60) {
            logo_width = 80
        } else if (company_address.length >=57 || head_line3.length >= 57) {
            logo_width = 70
        }
        headerLeft = {
            image: logoBase64Img, width: logo_width, margin:[8,-2,0,0],
        }
        headerCenter = company_name+'\n'+company_address+'\n'+head_line3

        let paymentVoucherNoRow
        paymentVoucherNoRow = [
            {text: '' , style: 'normalNo', margin:[0,15,0,0]},
            {text: 'เลขที่ '+payment_voucher_number, style: 'normalRightBold', colSpan: 2, margin:[0,15,0,0]},
            ''
        ]

        let docDefinition = {
            pageOrientation: 'portrait',
            pageSize: 'A4',
            pageMargins: [ 40, 35, 40, 0 ],
            // background: {image: 'book', width: 600},
            content: [
                {
                    table: {
                        widths: [ '15%', '70%', '15%' ],
                        body: [
                            [
                                headerLeft,
                                {
                                    text: headerCenter,
                                    style: 'textBoldHead',
                                    margin:[50,5,0,0],
                                    colSpan: 2,
                                },
                                {text: '', style: 'normal'},
                            ],
                            [
                                {text: '' , style: 'normalCenter'},
                                {text: 'ใบสำคัญจ่าย', style: 'textBoldCenter', margin:[0,25,0,0]},
                                {text: '', style: 'normalRight'},
                            ],
                            paymentVoucherNoRow,
                            [
                                {text: ' ' , style: 'normalCenter'},
                                {text: 'วันที่ '+ payment_voucher_date_thai, style: 'normalRight', colSpan: 2},
                                ''
                            ],
                        ],
                    },
                    layout: 'noBorders',
                    margin:[0,0,0,10],
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'จ่ายให้', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_name,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'ที่อยู่', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_address,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'เลขประจำตัวผู้เสียภาษี', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_tax_number,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1,
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'ชำระโดย', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: pay_method_type,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1,
                    margin:[0,0,0,10],
                },

                {
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        widths: [ '14%', '48%', '22%', '16%' ],
                        // heights: [20, 30],
                        body: [
                            [
                                {text: 'ลำดับ', style: 'myCellBold'},
                                {text: 'รายการ', style: 'myCellBold', colSpan: 2,},
                                '',
                                {text: 'จำนวนเงิน', style: 'myCellBold'}
                            ],
                            [
                                {text: '1', style: 'myCellDetail', border: [true,false,false,true], margin:[0,5,0,0]},
                                {
                                    columns: [
                                        {text: payment_voucher_name,  style: 'myCellSmall', margin:[8,5,0,0]},
                                    ],
                                    columnGap: 0,
                                    lineHeight:8,
                                    colSpan: 2,
                                },
                                '',
                                {text: NumberUtil.addCommas(String(payment_voucher_amount)), style: 'myCellPrice', margin:[0,5,0,0]}
                            ],
                            [
                                {text: '( '+payment_voucher_amount_text+' )', style: 'myCellBold', colSpan: 3, border: [true, false, true, true], margin:[0,3,0,3]},
                                '',
                                '',
                                {text: NumberUtil.addCommas(String(payment_voucher_amount)), style: 'myCellPrice', margin:[0,3,0,3]}
                            ],
                        ]
                    },
                    columnGap: 0,
                },
                {
                    table: {
                        widths: [ '33%', '33%', '33%' ],
                        body: [
                            [
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false], margin: [0,25,0,0]
                                },
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false], margin: [0,25,0,0]
                                },
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter', border: [false, false, false, false], margin: [0,25,0,0]
                                },
                            ],
                            [
                                {text: payee_name , style: 'smallCenter', border: [false, false, false, false], margin: [0,2,0,0]},
                                {text: payer_name, style: 'smallCenter', border: [false, false, false, false], margin: [0,2,0,0]},
                                {text: approver_name, style: 'smallCenter', border: [false, false, false, false], margin: [2,2,0,0]}
                            ],
                            /*[
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-22,2,0,0]
                                },
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-16,2,0,0]
                                },
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-16,2,0,0]
                                },
                            ],*/
                            [
                                {text: 'ผู้รับเงิน',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [0,0,0,0]
                                },
                                {text: 'ผู้จ่ายเงิน',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [0,0,0,0]
                                },
                                {text: 'ผู้อนุมัติ',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [0,0,0,0]
                                },
                            ],
                        ]
                    }
                },
            ],
            images:{
                emptySeal: 'data:image/png;base64,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'
            },
            styles: {
                normal: {
                    fontSize: 16,
                },
                normalNo: {
                    fontSize: 16,
                    bold: true,
                },
                normalCenter: {
                    fontSize: 16,
                    alignment: 'center'
                },
                normalRight: {
                    fontSize: 16,
                    alignment: 'right',
                },
                normalRightBold: {
                    fontSize: 16,
                    alignment: 'right',
                    bold: true,
                },
                textBold: {
                    fontSize: 16,
                    bold: true,
                },
                textBoldCenter: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                textBoldHead: {
                    fontSize: 15,
                    bold: true,
                    alignment: 'left'
                },
                smallCenter: {
                    fontSize: 14,
                    alignment: 'center',
                },
                smallCenterBold: {
                    fontSize: 14,
                    alignment: 'center',
                    bold: true,
                },
                smallRightBold: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                bodyhead: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                body: {
                    fontSize: 14,
                },
                bodycompany: {
                    fontSize: 14,
                    bold: true,
                },
                anotherStyle: {
                    italic: true,
                },
                myCell: {
                    fontSize: 16,
                    // fillColor: '#BEBEBE',
                    alignment: 'center',
                    // bold: true,
                },
                myCellBold: {
                    fontSize: 14,
                    // fillColor: '#BEBEBE',
                    alignment: 'center',
                    bold: true,
                },
                myCellSmall: {
                    fontSize: 14,
                },
                myCellSmallWhite: {
                    fontColor: '#ffffff',
                    fontSize: 14,
                },
                myCellDetail: {
                    fontSize: 14,
                    alignment: 'center',
                },
                myCellPrice: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                myCellSumPrice: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                myCellSumText: {
                    fontSize: 14,
                    fillColor: '#D3D3D3',
                    alignment: 'left',
                    bold: true,
                },
                myCellSumCost: {
                    fontSize: 14,
                    fillColor: '#D3D3D3',
                    alignment: 'right',
                    bold: true,
                },
                myCellSumTextCost: {
                    fontSize: 14,
                    fillColor: '#FF9933',
                    alignment: 'left',
                    bold: true,
                },
                myCellSumTextCostNum: {
                    fontSize: 14,
                    fillColor: '#FF9933',
                    alignment: 'right',
                    bold: true,
                },
            },
            defaultStyle: {
                font: 'THSarabunNew'
            }
        };
        pdfMake.createPdf(docDefinition).open();
    }

    // printPaymentVoucherCarSell
    printPaymentVoucherCarSell(){
        const {company_setting, logoBase64Img} = this.state

        let company_name = company_setting.company_name
        let company_address = company_setting.company_address
        let juristic_number = company_setting.juristic_number
        let company_tel = company_setting.company_tel === '' ? '-' : company_setting.company_tel
        let head_line3 = 'โทร. '+ company_tel + ' เลขประจำตัวผู้เสียภาษี '+ juristic_number

        let payment_voucher_number = this.state.payment_voucher_number
        let payment_voucher_date = this.state.payment_voucher_date
        let payment_voucher_date_thai = this.state.payment_voucher_date_thai
        let payee_name = this.state.payee_name === null || this.state.payee_name === '' ? '(.................................................................)' : '( '+this.state.payee_name+' )'
        let payer_name= this.state.payer_name === null || this.state.payer_name === '' ? '(.................................................................)' : '( '+this.state.payer_name+' )'
        let approver_name= this.state.approver_name === null || this.state.approver_name === '' ? '(.................................................................)' : '( '+this.state.approver_name+' )'
        let author_name= this.state.author_name === null || this.state.author_name === '' ? '(......................................................................)' : '( '+this.state.author_name+' )'
        let reviewer_name= this.state.reviewer_name === null || this.state.reviewer_name === '' ? '(...........................................................................)' : '( '+this.state.reviewer_name+' )'
        let pay_method= this.state.pay_method
        let pay_method_detail= this.state.pay_method_detail
        let status_bill= this.state.status_bill
        let center_id= this.state.center_id
        let car_repair_id= this.state.car_repair_id
        let expense_id= this.state.expense_id
        let expense_type_id= this.state.expense_type_id
        let center_name= this.state.center_name
        let center_address= this.state.center_address
        let center_tax_number= this.state.center_tax_number
        let payment_voucher_name= this.state.car_repair_name
        let payment_voucher_amount= this.state.car_repair_cost
        let payment_voucher_details = this.state.payment_voucher_details

        let pay_method_type
        if(pay_method === 'cash'){
            pay_method_type = 'เงินสด'
        }else if(pay_method === 'transfer'){
            pay_method_type = 'เงินโอน'
        }else {
            pay_method_type = 'เช็ค' + ' ' + pay_method_detail
        }

        let payment_voucher_amount_text = ThaiBaht(payment_voucher_amount);

        let headerLeft
        let headerCenter
        let logo_width = 90
        if (company_address.length >=60 || head_line3.length >= 60) {
            logo_width = 80
        } else if (company_address.length >=57 || head_line3.length >= 57) {
            logo_width = 70
        }
        headerLeft = {
            image: logoBase64Img, width: logo_width, margin:[8,-2,0,0],
        }
        headerCenter = company_name+'\n'+company_address+'\n'+head_line3

        let paymentVoucherNoRow
        paymentVoucherNoRow = [
            {text: '' , style: 'normalNo', margin:[0,10,0,0]},
            {text: 'เลขที่ '+payment_voucher_number, style: 'normalRightBold', colSpan: 2, margin:[0,10,0,0]},
            ''
        ]

        let details = []
        let rowTitle = [
            {text: 'ลำดับ', style: 'myCellBold'},
            {text: 'รายการ', style: 'myCellBold', colSpan: 2,},
            '',
            {text: 'จำนวนเงิน', style: 'myCellBold'}
        ]

        /*let rowItem = [
                {text: '1', style: 'myCellDetail', border: [true,false,false,true], margin:[0,5,0,0]},
                {
                    columns: [
                        {text: payment_voucher_name,  style: 'myCellSmall', margin:[8,5,0,0]},
                    ],
                    columnGap: 0,
                    lineHeight:8,
                    colSpan: 2,
                },
                '',
                {text: NumberUtil.addCommas(String(payment_voucher_amount)), style: 'myCellPrice', margin:[0,5,0,0]}
        ]*/

        let rowBathText = [
            {text: '( '+payment_voucher_amount_text+' )', style: 'myCellBold', colSpan: 3, border: [true, false, true, true], margin:[0,3,0,3]},
            '',
            '',
            {text: NumberUtil.addCommas(String(payment_voucher_amount)), style: 'myCellPrice', margin:[0,3,0,3]}
        ]


        details.push(rowTitle)
        // details.push(rowItem)
        for (let i = 0 ; i < payment_voucher_details.length ; i++) {
            let payment_voucher_detail = payment_voucher_details[i]
            let payment_voucher_text = payment_voucher_detail.payment_voucher_text
            let payment_voucher_amount = payment_voucher_detail.payment_voucher_amount
            let index = i +1
            let payment_voucher_amount_text = payment_voucher_amount === 0.00 ? '' : NumberUtil.addCommas(String(payment_voucher_amount))
            let rowItem = [
                {text: String(index), style: 'myCellDetail', border: [true,false,false,true], margin:[0,5,0,0]},
                {
                    columns: [
                        {text: payment_voucher_text,  style: 'myCellSmall', margin:[8,5,0,0]},
                    ],
                    columnGap: 0,
                    lineHeight: 0,
                    colSpan: 2,
                },
                '',
                {text: payment_voucher_amount_text, style: 'myCellPrice', margin:[0,5,0,0]}
            ]
            details.push(rowItem)
        }

        details.push(rowBathText)


        let docDefinition = {
            pageOrientation: 'portrait',
            pageSize: 'A4',
            pageMargins: [ 40, 18, 40, 0 ],
            // background: {image: 'book', width: 600},
            content: [
                {
                    table: {
                        widths: [ '15%', '70%', '15%' ],
                        body: [
                            [
                                headerLeft,
                                {
                                    text: headerCenter,
                                    style: 'textBoldHead',
                                    margin:[50,5,0,0],
                                    colSpan: 2,
                                },
                                {text: '', style: 'normal'},
                            ],
                            [
                                {text: '' , style: 'normalCenter'},
                                {text: 'ใบสำคัญจ่าย', style: 'textBoldCenter', margin:[0,3,0,0]},
                                {text: '', style: 'normalRight'},
                            ],
                            paymentVoucherNoRow,
                            [
                                {text: ' ' , style: 'normalCenter'},
                                {text: 'วันที่ '+ payment_voucher_date_thai, style: 'normalRight', colSpan: 2},
                                ''
                            ],
                        ],
                    },
                    layout: 'noBorders',
                    margin:[0,0,0,5],
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'จ่ายให้', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_name,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'ที่อยู่', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_address,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'เลขประจำตัวผู้เสียภาษี', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: center_tax_number,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1,
                },
                {
                    columns: [
                        { width: '25%',
                            text: 'ชำระโดย', style: 'textBold',
                        },
                        { width: '75%', style: 'normal',
                            text: pay_method_type,
                        },
                    ],
                    columnGap: 0,
                    lineHeight:1,
                    margin:[0,0,0,8],
                },
                {
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        widths: [ '14%', '48%', '22%', '16%' ],
                        // heights: [20, 30],
                        body: details
                    },
                    columnGap: 0,
                    margin:[0,0,0,5],
                },
                {
                    table: {
                        widths: [ '50%', '50%'],
                        body: [
                            [
                                {text: 'ผู้จัดทำ...........................................................',
                                    style: 'smallCenter',
                                    border: [true, true, true, false], margin: [0,16,0,0]
                                },
                                {text: 'ผู้ตรวจสอบ...........................................................',
                                    style: 'smallCenter',
                                    border: [true, true, true, false], margin: [0,16,0,0]
                                },
                            ],
                            [
                                {text: author_name , style: 'smallCenter', border: [true, false, true, false], margin: [0,0,0,0]},
                                {text: reviewer_name, style: 'smallCenter', border: [true, false, true, false], margin: [0,0,0,0]},
                            ],
                            [
                                {text: 'วันที่.................................................',
                                    style: 'smallCenter',
                                    border: [true, false, true, true],
                                    margin: [0,0,0,0]
                                },
                                {text: 'วันที่.................................................',
                                    style: 'smallCenter',
                                    border: [true, false, true, true],
                                    margin: [0,0,0,0]
                                },
                            ],
                        ]
                    },
                    margin:[0,0,0,5],
                },
                {
                    table: {
                        widths: [ '33%', '33%', '34%' ],
                        body: [
                            [
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter',
                                    border: [true, true, true, false], margin: [0,18,0,0]
                                },
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter',
                                    border: [true, true, true, false], margin: [0,18,0,0]
                                },
                                {text: 'ลงชื่อ...........................................................',
                                    style: 'smallCenter', border: [true, true, true, false], margin: [0,18,0,0]
                                },
                            ],
                            [
                                {text: payee_name , style: 'smallCenter', border: [true, false, true, false], margin: [0,0,0,0]},
                                {text: payer_name, style: 'smallCenter', border: [true, false, true, false], margin: [0,0,0,0]},
                                {text: approver_name, style: 'smallCenter', border: [true, false, true, false], margin: [0,0,0,0]}
                            ],
                            /*[
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-22,2,0,0]
                                },
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-16,2,0,0]
                                },
                                {text: 'วันที่ ........................................................',
                                    style: 'smallCenter',
                                    border: [false, false, false, false],
                                    margin: [-16,2,0,0]
                                },
                            ],*/
                            [
                                {text: 'ผู้รับเงิน',
                                    style: 'smallCenter',
                                    border: [true, false, true, true],
                                    margin: [0,0,0,0]
                                },
                                {text: 'ผู้จ่ายเงิน',
                                    style: 'smallCenter',
                                    border: [true, false, true, true],
                                    margin: [0,0,0,0]
                                },
                                {text: 'ผู้อนุมัติ',
                                    style: 'smallCenter',
                                    border: [true, false, true, true],
                                    margin: [0,0,0,0]
                                },
                            ],
                        ]
                    }
                },
            ],
            images:{
                emptySeal: 'data:image/png;base64,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'
            },
            styles: {
                normal: {
                    fontSize: 15,
                },
                normalNo: {
                    fontSize: 16,
                    bold: true,
                },
                normalCenter: {
                    fontSize: 15,
                    alignment: 'center'
                },
                normalRight: {
                    fontSize: 15,
                    alignment: 'right',
                },
                normalRightBold: {
                    fontSize: 16,
                    alignment: 'right',
                    bold: true,
                },
                textBold: {
                    fontSize: 15,
                    bold: true,
                },
                textBoldCenter: {
                    fontSize: 17,
                    bold: true,
                    alignment: 'center'
                },
                textBoldHead: {
                    fontSize: 15,
                    bold: true,
                    alignment: 'left'
                },
                smallCenter: {
                    fontSize: 14,
                    alignment: 'center',
                },
                smallCenterBold: {
                    fontSize: 14,
                    alignment: 'center',
                    bold: true,
                },
                smallRightBold: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                bodyhead: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                body: {
                    fontSize: 14,
                },
                bodycompany: {
                    fontSize: 14,
                    bold: true,
                },
                anotherStyle: {
                    italic: true,
                },
                myCell: {
                    fontSize: 16,
                    // fillColor: '#BEBEBE',
                    alignment: 'center',
                    // bold: true,
                },
                myCellBold: {
                    fontSize: 14,
                    // fillColor: '#BEBEBE',
                    alignment: 'center',
                    bold: true,
                },
                myCellSmall: {
                    fontSize: 14,
                },
                myCellSmallWhite: {
                    fontColor: '#ffffff',
                    fontSize: 14,
                },
                myCellDetail: {
                    fontSize: 14,
                    alignment: 'center',
                },
                myCellPrice: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                myCellSumPrice: {
                    fontSize: 14,
                    alignment: 'right',
                    bold: true,
                },
                myCellSumText: {
                    fontSize: 14,
                    fillColor: '#D3D3D3',
                    alignment: 'left',
                    bold: true,
                },
                myCellSumCost: {
                    fontSize: 14,
                    fillColor: '#D3D3D3',
                    alignment: 'right',
                    bold: true,
                },
                myCellSumTextCost: {
                    fontSize: 14,
                    fillColor: '#FF9933',
                    alignment: 'left',
                    bold: true,
                },
                myCellSumTextCostNum: {
                    fontSize: 14,
                    fillColor: '#FF9933',
                    alignment: 'right',
                    bold: true,
                },
            },
            defaultStyle: {
                font: 'THSarabunNew'
            }
        };
        pdfMake.createPdf(docDefinition).open();
    }

    manageAddEditButton() {
        if (this.state.payment_voucher_id === null) {
            return (
                <button type="button"
                        className="btn btn-success btn-md mr-2"
                        style={{width: 120}}
                        onClick={()=> this.savePaymentVoucher('add')}
                >
                    <i className="icon-check"/> บันทึก
                </button>
            )
        } else if (this.state.payment_voucher_id !== null) {
            return (
                <button type="button"
                        className="btn btn-warning btn-md mr-2"
                        style={{width: 120}}
                        onClick={()=> this.savePaymentVoucher('edit')}
                >
                    <i className="icon-pencil"/> แก้ไข
                </button>
            )
        }
    }

    managePrintButton() {
        if (this.state.payment_voucher_id !== null) {
            return <button type="button"
                           className="btn btn-primary btn-md mr-2"
                           style={{width: 120}}
                           onClick={() => {
                               let payment_voucher_type = this.state.payment_voucher_type
                               if (payment_voucher_type==='car_repair') {
                                   this.printPaymentVoucher()
                               } else if (payment_voucher_type==='car_sell') {
                                   this.printPaymentVoucherCarSell()
                               }

                           }}
            >
                <i className="icon-printer"/>  พิมพ์
            </button>
        }
        return null
    }

    /*updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }*/

    /*componentWillUnmount() {
        this.mounted = false
        window.removeEventListener('resize', this.updateWindowDimensions);
    }*/

    //กำหนดค่าเริ่มต้นสำหรับการใช้งาน
    componentWillMount () {
        let car_repair_id = ''
        let car_sell_id = ''
        let payment_voucher_type = ''
       if (this.props.car_sell_id === undefined) {
           const queryString = require('query-string')
           let car_repair = queryString.parse(this.props.location.search)
           car_repair_id = car_repair.car_repair_id === undefined ? '': car_repair.car_repair_id
           car_sell_id = car_repair.car_sell_id === undefined ? '': car_repair.car_sell_id
           payment_voucher_type = car_repair.car_repair_id === undefined ? 'car_sell': 'car_repair'
       } else {
           payment_voucher_type = this.props.payment_voucher_type
           car_sell_id = this.props.car_sell_id
           // console.log(payment_voucher_type, ' ,  car_sell_id = ', car_sell_id)
       }


        this.setState({
            user: JSON.parse(this.props.user),
            car_repair_id: car_repair_id,
            car_sell_id: car_sell_id,
            payment_voucher_type: payment_voucher_type
        });
    }

    async componentDidMount () {

        this.mounted = true
        await this.loadCompanyLogoBase64();
        await this.loadCompanySetting();
        await this.loadPaymentVoucher();

        if(this.state.payment_voucher_type === 'car_repair') {
            await this.loadCarRepairData();
        } else if (this.state.payment_voucher_type ==='car_sell') {
            await this.loadCarSellData();
            await this.loadPaymentVoucherDetailData();
        }

        let payment_voucher_id = this.state.payment_voucher_id

        // create new payment_voucher
        if(payment_voucher_id === null){
            let startDatePaymentVoucher = new Date()
            let payment_voucher_date = format(startDatePaymentVoucher, 'yyyy-MM-dd')
            let payment_voucher_date_thai = DateUtil.convertLongDateThai(payment_voucher_date)

            this.setState({
                payment_voucher_date,
                payment_voucher_date_thai
            })
        }
        /*this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);*/
    }

    onChangeInputText(payment_voucher_detail, index, event) {
        let payment_voucher_details = this.state.payment_voucher_details
        // let name = event.target.name
        let value = event.target.value
        // let payment_voucher_detail_id = payment_voucher_detail.payment_voucher_detail_id
        let form_status = payment_voucher_detail.form_status === 'exits' ? 'edit' : payment_voucher_detail.form_status

        payment_voucher_details[index] =  {...payment_voucher_detail, payment_voucher_text: value, form_status: form_status}

        this.setState({
            payment_voucher_details: payment_voucher_details
        })
    }

    onChangeInputNumber(payment_voucher_detail, index, value) {
        let payment_voucher_details = this.state.payment_voucher_details
        // let name = event.target.name
        // let value = event.target.value
        // let payment_voucher_detail_id = payment_voucher_detail.payment_voucher_detail_id
        if (value === '') {

            let form_status = payment_voucher_detail.form_status === 'exits' ? 'edit' : payment_voucher_detail.form_status
            payment_voucher_details[index] =  {...payment_voucher_detail, payment_voucher_amount: '', form_status: form_status}
            this.setState({
                payment_voucher_details: payment_voucher_details
            }, () => {
                this.calSumTotals()
            })

            return;
        }

        // value = NumberUtil.removeComma(String(value))
        // if(!isNumber(value)) {
        //     AlertError('กรุณากรอกตัวเลข')
        //     return
        // }
        // value = NumberUtil.addCommas(value);

        let form_status = payment_voucher_detail.form_status === 'exits' ? 'edit' : payment_voucher_detail.form_status

        payment_voucher_details[index] =  {...payment_voucher_detail, payment_voucher_amount: value, form_status: form_status}

        this.setState({
            payment_voucher_details: payment_voucher_details
        }, () => {
            this.calSumTotals()
        })
    }

    calSumTotals() {
        let payment_voucher_details = this.state.payment_voucher_details
        let payment_voucher_detail_filter = payment_voucher_details.filter(pvd => pvd.payment_voucher_amount !== '' );
        let sum_totals = payment_voucher_detail_filter.reduce((acc,next) => acc + Number(NumberUtil.removeComma(String(next.payment_voucher_amount))), 0)
        this.setState({
            sum_totals: sum_totals
        })
    }

    renderPaymentVoucherTable() {
        const { payment_voucher_type } = this.state
        if (payment_voucher_type==='car_repair') {
            return (
                <div className="row mt-5" style={styles.tablePd}>
                    <table style={styles.table}>
                        <tbody>
                        <tr>
                            <th className="text-nowrap" style={styles.tableTh} width={'12%'}>ลำดับ</th>
                            <th className="text-nowrap" style={styles.tableTh} width={'68%'}>รายการ</th>
                            <th className="text-nowrap" style={styles.tableTh} width={'20%'}>จำนวนเงิน</th>
                        </tr>

                        <tr>
                            <td style={styles.tableTdLeft}>1</td>
                            <td style={styles.tableTdCenter} >
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'30%'}>
                                            <input type="text" style={styles.inputData}
                                                   name="car_repair_name"
                                                   className="form-control"
                                                   placeholder=""
                                                   value={this.state.car_repair_name}
                                                   onChange={this.handleOnChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr><td>&nbsp;</td></tr>
                                    </tbody>
                                </table>
                            </td>

                            <td style={styles.tableTdRigth}>
                                <table style={{width: '100%'}}>
                                    <tbody>
                                    <tr>
                                        <td style={styles.tableTdRigthInner}>
                                            {NumberUtil.addCommas(String(this.state.car_repair_cost))}
                                            {
                                                //this.genCarPrice()
                                            }
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table style={styles.table}>
                        <tbody>
                        <tr>
                            <td style={styles.amountsText} width={'63%'}>
                                {ThaiBaht(this.state.car_repair_cost)}
                            </td>
                            <td className="text-nowrap" style={styles.tableTdRigth} width={'17%'}><strong>รวมเป็นเงิน &nbsp;</strong></td>
                            <td style={styles.tableTdRigth} >
                                <NumberFormat
                                    className="form-control text-right"
                                    thousandSeparator={true}
                                    decimalScale={2} fixedDecimalScale
                                    min={0}
                                    max={1000000000}
                                    step={1000}
                                    size={10}
                                    allowNegative={false}
                                    value={this.state.car_repair_cost}
                                    onValueChange = {(values) => {
                                        const {value} = values;
                                        this.setState({car_repair_cost: value},()=>{
                                            //this.calInvoice()
                                        })
                                    }}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            )
        } else if (payment_voucher_type==='car_sell') {
            // read payment_voucher_detail
            let payment_voucher_details = this.state.payment_voucher_details
            let sum_totals = this.state.sum_totals
            // let payment_voucher_detail_filter = payment_voucher_details.filter(pvd => pvd.payment_voucher_amount !== '' );
            // let sum_totals = payment_voucher_detail_filter.reduce((acc,next) => acc + Number(NumberUtil.removeComma(String(next.payment_voucher_amount))), 0)

            return (
                <div className="row mt-5" style={styles.tablePd}>
                    <table style={styles.table}>
                        <thead>
                        <tr>
                            <th className="text-nowrap" style={styles.tableTh} width={'12%'}>ลำดับ</th>
                            <th className="text-nowrap" style={styles.tableTh} width={'68%'}>รายการ</th>
                            <th className="text-nowrap" style={styles.tableTh} width={'20%'}>จำนวนเงิน</th>
                        </tr>
                        </thead>
                        <tbody>
                         {
                             payment_voucher_details.map((pvd, index) => (
                                 <tr key={index}>
                                     <td style={styles.tableTdLeft}>{index+1}</td>
                                     <td style={styles.tableTdLeft}>
                                         <input type="text" style={styles.inputData}
                                                className="form-control"
                                                placeholder=""
                                                value={pvd.payment_voucher_text}
                                                onChange={(e)=> this.onChangeInputText(pvd, index, e)}
                                         />
                                     </td>
                                     <td style={styles.tableTdRigth}>
                                         {/*<input
                                             type="text"
                                             maxLength={10}
                                             name="payment_voucher_amount"
                                             style={styles.input}
                                             value={pvd.payment_voucher_amount !== '' ? pvd.payment_voucher_amount : '' }
                                             onChange={(event)=> this.onChangeInputNumber(pvd, index, event)}
                                         />*/}

                                         <NumberFormat
                                             className="form-control text-right"
                                             thousandSeparator={true}
                                             decimalScale={2}
                                             fixedDecimalScale
                                             min={0}
                                             max={1000000000}
                                             step={1000}
                                             size={10}
                                             allowNegative={false}
                                             value={pvd.payment_voucher_amount}
                                             onValueChange = {(values) => {
                                                 const {value} = values;
                                                 this.onChangeInputNumber(pvd, index, value)
                                             }}
                                         />
                                     </td>
                                 </tr>
                             ))
                         }
                        </tbody>
                    </table>
                    <table style={styles.table}>
                        <tbody>
                        <tr>
                            <td style={styles.amountsText} width={'63%'}>
                                {ThaiBaht(sum_totals)}
                            </td>
                            <td className="text-nowrap" style={styles.tableTdRigth} width={'17%'}><strong>รวมเป็นเงิน &nbsp;</strong></td>
                            <td style={styles.tableTdRigth} >
                                <NumberFormat
                                    className="form-control text-right"
                                    thousandSeparator={true}
                                    decimalScale={2} fixedDecimalScale
                                    min={0}
                                    max={1000000000}
                                    step={1000}
                                    size={10}
                                    allowNegative={false}
                                    value={sum_totals}
                                    displayType={'text'}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            )
        }
        return <> </>
    }

    render () {
        const {company_setting} = this.state
        let logoWidth = 100
        let base64Img = this.state.logoBase64Img

        return(
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <Loading isLoading={this.state.isLoading} />
                        <div className="card-header">
                            <strong className="text-title">ใบสำคัญจ่าย</strong>
                        </div>

                        <div className="card-block" style={{paddingLeft: 50, paddingRight: 50}}>
                            <div className="row" style={{lineHeight: 2.0}}>
                                <table style={styles.table}>
                                    <tbody>
                                        <tr>
                                            <td width={'22%'} style={styles.tdContentCenter} >
                                                <img src={base64Img} width={logoWidth} alt='logo' />
                                            </td>

                                            <td style={styles.tdContentCenter}>
                                                {
                                                    this.state.company_setting !== null ? (
                                                        <>
                                                            <div className="text-center">
                                                                {
                                                                    company_setting.company_name
                                                                }
                                                                <br/>
                                                                {
                                                                    company_setting.company_address
                                                                }
                                                                <br/>
                                                                หมายเลขผู้เสียภาษี {  company_setting.juristic_number } &nbsp; &nbsp; เบอร์โทรศัพท์ { company_setting.company_tel }
                                                            </div>
                                                        </>
                                                    ) : null
                                                }
                                            </td>

                                            <td width={'22%'}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row">
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'40%'}>&nbsp;</td>
                                        <td width={'30%'}>&nbsp;</td>

                                        <td>
                                            <div className="form-inline mt-5">
                                                เลขที่&nbsp;&nbsp;{this.state.check_doc_no === 'repeat'  ? "( ซ้ำ )" : ''}
                                                <input className="form-control ml-3"
                                                       style={{...styles.inputDataNum ,borderColor:setInputStyleDocNo(this.state.check_doc_no)}}
                                                       value={this.state.payment_voucher_number || ''}
                                                       onChange={(e) => {
                                                           this.setState({
                                                               payment_voucher_number: e.target.value,
                                                               check_doc_no: 'noset'
                                                           })
                                                       }}

                                                       onBlur={(e) => {
                                                           let val = e.target.value
                                                           let doc_no = this.state.payment_voucher_number
                                                           if (val !== '') {
                                                               if (val !== doc_no) {
                                                                   this.setState({
                                                                       payment_voucher_number: val
                                                                   }, () => this.checkPaymentVoucherNumberRepeat())
                                                               } else {
                                                                   this.checkPaymentVoucherNumberRepeat()
                                                               }
                                                           }

                                                       }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row">
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'40%'}>&nbsp;</td>
                                        <td width={'30%'}>&nbsp;</td>
                                        <td>
                                            <div className="row form-inline mt-2 ml-3">
                                                วันที่ &nbsp;&nbsp;&nbsp;
                                                <input readOnly={true}
                                                       className="form-control"
                                                       style={{width: 160}}
                                                       value={this.state.payment_voucher_date_thai === null ? '' : this.state.payment_voucher_date_thai}
                                                />
                                                <button type="button"
                                                        className="btn btn-primary ml-1"
                                                        onClick={(e) => {
                                                            this.setState({
                                                                isOpenDatePaymentVoucher: true
                                                            });
                                                        }}
                                                >
                                                    <i className="icon-calendar"/>
                                                </button>

                                                {
                                                    this.state.isOpenDatePaymentVoucher && (
                                                        <DatePicker
                                                            selected={this.state.startDatePaymentVoucher}
                                                            onChange={this.handleDatePaymentVoucher}
                                                            dateFormat="yyyy-MM-dd"
                                                            inline
                                                        />
                                                    )
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-5" style={{lineHeight: 2.0}}>
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'10%'}/>
                                        <td>
                                            <div className="form-inline mt-3">
                                                จ่ายให้
                                                <input type="text" style={styles.inputData}
                                                       name="center_name"
                                                       className="form-control ml-5"
                                                       placeholder=""
                                                       value={this.state.center_name}
                                                       onChange={this.handleOnChange}
                                                        /*onChange={(e) => {
                                                            let val = e.target.value;
                                                            this.setState({
                                                                center_name: val
                                                            });
                                                        }}*/
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-1">
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'10%'}/>
                                        <td>
                                            <div className="form-inline">
                                                ที่อยู่ &nbsp;&nbsp;
                                                <input type="text" style={styles.inputData}
                                                       name="center_address"
                                                       className="form-control ml-5"
                                                       placeholder=""
                                                       value={this.state.center_address}
                                                       onChange={this.handleOnChange}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-1">
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'10%'}/>
                                        <td>
                                            <div className="form-inline">
                                                เลขประจำตัวผู้เสียภาษี &nbsp;
                                                <input type="text" style={styles.inputData}
                                                       name="center_tax_number"
                                                       className="form-control ml-3"
                                                       placeholder=""
                                                       value={this.state.center_tax_number || ''}
                                                       onChange={this.handleOnChange}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-5">
                                <table style={styles.table}>
                                    <tbody>
                                    <tr>
                                        <td width={'10%'}/>
                                        <td>
                                            <div className="form-inline">
                                                ชำระโดย &nbsp;&nbsp;&nbsp;&nbsp;
                                                <input className="ml-4 mr-2"
                                                       type="radio"
                                                       name="pay_method"
                                                       id="pay_method1"
                                                       value="cash"
                                                       checked={this.state.pay_method === 'cash'}
                                                       onChange={(e) => {
                                                           let val = e.target.value
                                                           this.setState({
                                                               pay_method: val
                                                           })
                                                       }}
                                                />
                                                <label id="pay_method1" className="mr-5">เงินสด</label>
                                            </div>

                                            <div className="form-inline mt-2 ml-5">
                                                <input className="ml-5 mr-2"
                                                       type="radio"
                                                       name="pay_method"
                                                       id="pay_method2"
                                                       value="transfer"
                                                       checked={this.state.pay_method === 'transfer'}
                                                       onChange={(e) => {
                                                           let val = e.target.value
                                                           this.setState({
                                                               pay_method: val
                                                           })
                                                       }}
                                                />
                                                <label id="pay_method2" className="mr-5">เงินโอน</label>
                                            </div>

                                            <div className="form-inline mt-2 ml-5">
                                                <input className="ml-5 mr-2"
                                                       type="radio"
                                                       name="pay_method"
                                                       id="pay_method3"
                                                       value="cheque"
                                                       checked={this.state.pay_method === 'cheque'}
                                                       onChange={(e) => {
                                                           let val = e.target.value
                                                           this.setState({
                                                               pay_method: val
                                                           })
                                                       }}
                                                />
                                                <label id="customer_type3" className="mr-2">เช็ค</label>

                                                <input type="text"
                                                       style={styles.inputTax}
                                                       className="form-control ml-1"
                                                       placeholder="ธนาคาร................เลขที่................ลงวันที่................"
                                                       disabled={this.state.pay_method !== 'cheque'}
                                                       name="pay_method_detail"
                                                       value={this.state.pay_method_detail || ''}
                                                       onChange={this.handleOnChange}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            {this.renderPaymentVoucherTable()}
                            <>
                                {this.state.payment_voucher_type==='car_sell' ?
                                    <div className="row mt-5 mb-3">
                                        <table style={styles.table}>
                                            <center>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p>ลงชื่อ......................................................(ผู้จัดทำ)</p>
                                                    </td>
                                                    <td style={{width:20}}></td>
                                                    <td>
                                                        <p>ลงชื่อ......................................................(ผู้ตรวจสอบ)</p>
                                                    </td>
                                                </tr>

                                            <tr>
                                                <td>
                                                    <input type="text" style={{ ...styles.inputData, width: 240}}
                                                           className="form-control mb-2"
                                                           placeholder=""
                                                           name="author_name"
                                                           value={this.state.author_name || ''}
                                                           onChange={this.handleOnChange}
                                                    />
                                                </td>
                                                <td style={{width:20}}></td>
                                                <td>
                                                    <input type="text" style={{ ...styles.inputData, width: 240}}
                                                           className="form-control mb-2"
                                                           placeholder=""
                                                           name="reviewer_name"
                                                           value={this.state.reviewer_name || ''}
                                                           onChange={this.handleOnChange}
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                            <hr/>
                                        </center>
                                        </table>
                                    </div>
                                :
                                null
                                }
                            </>


                            <div className="row mt-5 mb-3">
                                <table style={styles.table}>
                                    <center>
                                    <tbody>
                                    <tr>
                                        <td className="mr-5">
                                            <p>ลงชื่อ......................................................(ผู้รับเงิน)</p>
                                        </td>
                                        <td style={{width:15}}></td>
                                        <td className="mr-5">
                                            <p>ลงชื่อ......................................................(ผู้จ่ายเงิน)</p>
                                        </td>
                                        <td style={{width:15}}></td>
                                        <td className="mr-5">
                                            <p>ลงชื่อ......................................................(ผู้อนุมัติ)</p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <input type="text" style={{ ...styles.inputData, width: 240}}
                                                   className="form-control mb-2"
                                                   placeholder=""
                                                   name="payee_name"
                                                   value={this.state.payee_name || ''}
                                                   onChange={this.handleOnChange}
                                            />
                                        </td>
                                        <td style={{width:15}}></td>
                                        <td>
                                            <input type="text" style={{ ...styles.inputData, width: 240}}
                                                   className="form-control mb-2"
                                                   placeholder=""
                                                   name="payer_name"
                                                   value={this.state.payer_name || ''}
                                                   onChange={this.handleOnChange}
                                            />
                                        </td>
                                        <td style={{width:15}}></td>
                                        <td>
                                            <input type="text" style={{ ...styles.inputData, width: 240}}
                                                   className="form-control mb-2"
                                                   placeholder=""
                                                   name="approver_name"
                                                   value={this.state.approver_name || ''}
                                                   onChange={this.handleOnChange}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                    </center>
                                </table>
                            </div>

                            <div className="col-md-12 text-right mt-5">
                                <div className="card-block">
                                    {this.manageAddEditButton()}
                                    {this.managePrintButton()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const styles = {
    table: {
        width: '100%',
        maxWidth: '100%'
    },
    tdContentCenter: {
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    tdContentRight: {
        textAlign: 'right',
        verticalAlign: 'middle',
        justifyContent: 'right',
    },
    tdContentLeft: {
        textAlign: 'left',
        verticalAlign: 'middle'
    },
    tableTh:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    tableTdLeft:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'center',
        verticalAlign: 'top',
    },
    tableTdCenter:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'left',
        verticalAlign: 'middle',
        paddingLeft: '0px',
    },
    tableTdRigth:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'right',
        verticalAlign: 'top',
    },
    tableTdRigthInner:{
        maxWidth: '100%',
        borderColor: '#fff',
        borderWidth: '0px',
        borderStyle: 'solid',
        textAlign: 'right',
        verticalAlign: 'top',
        paddingRight: '8px'
    },
    tablePd:{
        paddingLeft: '50px',
        paddingRight: '50px',
        lineHeight: '2.2',
    },
    amountsText:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'center',
        verticalAlign: 'middle',
        fontWeight: 'bold',
    },
    amountsTextNoBorder:{
        maxWidth: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    amountsRigth:{
        maxWidth: '100%',
        borderColor: '#626262',
        borderWidth: '1px',
        borderStyle: 'solid',
        textAlign: 'right',
        verticalAlign: 'top',
        fontWeight: 'bold',
    },
    buttonHeight: {
        height: 32,
    },
    inputData:{
        borderRadius: '5px',
        width: '450px',
    },
    inputTax:{
        borderRadius: '5px',
        width: '481px',
    },
    inputDataNo:{
        borderRadius: '5px',
        width: '100px'
    },
    inputDataNum:{
        borderRadius: '5px',
        width: '156px'
    },
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(PaymentVoucher)

